import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { gradingAcademyState, gradingOverviewState } from 'states/GradingOverview';
import { LoggedInState } from 'states/LoggedIn';

export function useIsOperator() {
  return useRecoilValue(LoggedInState)?.user?.type === 'A';
}

export function useMyUsername() {
  return useRecoilValue(LoggedInState)?.user?.username ?? null;
}

export function useMyName() {
  const user = useRecoilValue(LoggedInState)?.user;
  return user?.nickname || user?.username || null;
}

export function useGradingAcademy() {
  return useRecoilValue(gradingAcademyState);
}

export function useGradingLink() {
  const [searchParams] = useSearchParams();
  const academyName = searchParams.get('academy_name');
  return useCallback(
    (path, params = {}) => {
      const query = new URLSearchParams();
      if (academyName) {
        query.set('academy_name', academyName);
      }
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          query.set(key, String(value));
        }
      });
      const search = query.toString();
      return search ? `${path}?${search}` : path;
    },
    [academyName]
  );
}

export function useOverviewExam(examId) {
  const academy = useRecoilValue(gradingAcademyState);
  const synced = useRecoilValue(gradingOverviewState);
  if (academy === null || synced.academyId !== academy.id) return null;
  return synced.data?.exams.find((exam) => exam.examId === examId) ?? null;
}
